/**
 * Norco B2B catalog import (/admin-addbikes-norco). Hidden: the code stays in place but its route
 * and dashboard card are not rendered. Norco bikes are listed through "Norco, Ibis & other".
 */
export const NORCO_CATALOG_ENABLED = false;
